import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'AmazonMWS',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AmazonMWS_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AmazonMWS_DisplayText)
    ]
})
export class AmazonMWSLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Endpoint
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_MarketplaceID
    })
    public marketplaceID?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_SellerID
    })
    public sellerID?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_MwsAuthToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public mwsAuthToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessKeyID
    })
    public accessKeyId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AmazonAccessKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public secretKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
